module.exports = __webpack_public_path__ + "static/screen-day-1-8ee8ff4ea657565368fa64bd87684e05.png";